module.exports = __webpack_public_path__ + "static/media/contact_accepted.43f459ab.svg";